import type { TeamEntitlementsSnapshot, User } from '@kangaroo/shared';

const BILLING_RESTRICTED_ALLOWED_PATHS = new Set(['/drivers', '/sessions', '/billing']);

export function userCreatesPaidWorkspace(role: User['role'], parentRegistrationMode?: 'create' | 'join') {
  return role === 'TEAM_OWNER'
    || role === 'COACH'
    || (role === 'PARENT' && parentRegistrationMode !== 'join');
}

export function requiresSubscriptionRedirect(input: {
  user: Pick<User, 'teamId'> | null | undefined;
  entitlements: Pick<TeamEntitlementsSnapshot, 'requiresPaidPlan'> | null | undefined;
  pathname: string;
}) {
  if (!input.user?.teamId || !input.entitlements?.requiresPaidPlan) {
    return false;
  }

  if (!isHistoricalSessionsOnlyAccess(input)) {
    return input.pathname !== '/drivers' && input.pathname !== '/billing';
  }

  return !BILLING_RESTRICTED_ALLOWED_PATHS.has(input.pathname);
}

export function isHistoricalSessionsOnlyAccess(input: {
  user: Pick<User, 'teamId'> | null | undefined;
  entitlements: Pick<TeamEntitlementsSnapshot, 'requiresPaidPlan' | 'hasUsedStripeTrial' | 'isPartnerComp' | 'partnerProgramLabel'> | null | undefined;
}) {
  return Boolean(
    input.user?.teamId
      && input.entitlements?.requiresPaidPlan
      && input.entitlements.hasUsedStripeTrial
      && !input.entitlements.isPartnerComp
      && !input.entitlements.partnerProgramLabel,
  );
}
